<script setup lang="ts">
const { menuItems } = await useAuthMenu()

const { themeConfig } = useThemeConfig()
const menuVariant = computed(() => themeConfig.value?.header.variant)

// Currently hardcoded.
const menuItemClasses = 'text-muted-800 dark:text-muted-100 hover:text-muted-800 dark:hover:text-muted-400 border-b-2 border-transparent'
const menuItemActiveClasses = '!border-primary-500 !text-muted-900 dark:!text-muted-100 border-b-2'

// Tabs styling
const tabsBackgroundColorClass = computed(() => `bg-[var(--color-theme-menu-tabs-background)] dark:bg-muted-900`)
const tabStyle = computed(() => `
  w-fit items-center rounded-t-xl px-4
  border-t border-r border-l ${tabsBackgroundColorClass.value}
  border-[var(--color-theme-menu-tabs-border)] dark:border-muted-700
`)

// Note: there's an issue with the reactivity of the menuVariant.
// It's not fully reactive on the initial page load, but I fixed that by preloading the theme config through a middleware.
const navClass = computed(() => menuVariant.value === 'tab' ? tabStyle.value : '')

const useIcons = true
</script>

<template>
  <div class="hidden w-full overflow-x-auto transition-all duration-300 md:block">
    <Container :key="menuVariant" :full-width="themeConfig?.header.fullWidth">
      <nav
        :class="navClass"
        class="flex items-end"
      >
        <NuxtLink
          v-for="(item, index) in menuItems"
          :key="index"
          :to="item.to"
          class="flex items-center justify-center p-3 text-center transition-colors duration-300 first:pl-0"
          :class="[
            menuItemClasses,
          ]"
          :exact-active-class="menuItemActiveClasses"
        >
          <Icon
            v-if="useIcons"
            :name="item.icon?.name"
            class="mr-1 size-5"
          />
          <BaseText size="sm" weight="medium">
            {{ item.name }}
          </BaseText>
        </NuxtLink>
      </nav>
    </Container>
  </div>
</template>
